import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './cilindro_tipo_utils';

export const useCilindroTipoStore = defineStore('cilindroTipoStore', {
  state: () => ({
    entity: 'cilindro-tipo',
    cilindroTipoList: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllCilindroTipoHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.cilindroTipoList.splice(0, this.cilindroTipoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstCilindroTipo() {
      this.setPage(1);
      this.emptyList();
      await this.findAllCilindroTipoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.cilindroTipoList = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
